<div class="page-header">
    <div class="page-header-text" *ngIf="!isGracePayment">Initial premium payment details</div>
    <div class="page-header-text" *ngIf="isGracePayment">Payment details</div>
</div>
<div class="page-body">
    <div class="body-text">You may want to save or print this page for your records.</div>
    <div class="tM-20px bM-20px body-text" *ngIf="payment">
        <div class="dFlex bM-12px">
            <div class="width-50 body-bold">Confirmation number:</div>
            <div class="width-50">{{receiptId}}</div>
        </div>
        <div class="dFlex bM-12px">
            <div class="width-50 body-bold">Policy:</div>
            <div class="width-50">{{userInfo?.productType}} {{userInfo?.policyNumber}}</div>
        </div>
        <div class="dFlex bM-12px">
            <div class="width-50 body-bold">Payment Amount:</div>
            <div class="width-50">${{paymentAmount.toFixed(2)}}</div>
        </div>
        <div class="dFlex bM-12px">
            <div class="width-50 body-bold">Payment Method:</div>
            <div class="width-50" *ngIf="payment.bankDetails" >{{payment.paymentMethod}} ({{payment.bankDetails.bankAccountNumber | hideChars }})</div>
            <div class="width-50" *ngIf="payment.creditCard">{{payment.creditCard.cardType}} {{payment.paymentMethod}} (**** {{payment.creditCard.cardNumberLastFour}})</div>
        </div>
        <div class="dFlex bM-12px">
            <div class="width-50 body-bold">Account holder's name:</div>
            <div class="width-50" *ngIf="payment.bankDetails && payment.bankDetails.nameOnAccount">{{payment.bankDetails.nameOnAccount}}</div>
            <div class="width-50" *ngIf="payment.creditCard && payment.creditCard.nameOnCard">{{payment.creditCard.nameOnCard}}</div>
            <div class="width-50" *ngIf="payment.bankDetails && !payment.bankDetails.nameOnAccount">{{payment.bankDetails.firstName}} {{payment.bankDetails.lastName}}</div>
            <div class="width-50" *ngIf="payment.creditCard && !payment.creditCard.nameOnCard">{{payment.creditCard.firstName}} {{payment.creditCard.lastName}}</div>
        </div>
        <div class="dFlex bM-12px" *ngIf="payment.bankDetails && payment.bankDetails.address">
            <div class="width-50 body-bold">Account holder's address:</div>
            <div class="width-50">{{payment.bankDetails.address}}, {{payment.bankDetails.state}} {{payment.bankDetails.zipCode}}</div>
        </div>
        <div class="dFlex">
            <div class="width-50 body-bold">Payment date:</div>
            <div class="width-50">{{currentDate|date:'MM/dd/yyyy'}}</div>
        </div>
    </div>
</div>